import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
const MobileProductListingListFilter = t0 => {
  const $ = _c(15);
  const {
    id
  } = t0;
  const {
    filters: t1,
    toggleFilterOption
  } = useProductListingPageContext();
  let T0;
  let activeOptions;
  let label;
  let t2;
  let t3;
  if ($[0] !== id || $[1] !== t1 || $[2] !== toggleFilterOption) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const filters = t1 === undefined ? [] : t1;
      let t4;
      if ($[8] !== id) {
        t4 = filter => id === filter.id;
        $[8] = id;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      const currentFilter = filters.find(t4);
      if (!currentFilter) {
        t3 = null;
        break bb0;
      }
      const {
        label: t5,
        options
      } = currentFilter;
      label = t5;
      activeOptions = options.filter(_temp).map(_temp2);
      T0 = TogglePillGroup;
      t2 = options?.map(option_0 => ({
        ...option_0,
        onClick: () => {
          toggleFilterOption(id, option_0.id, option_0.label);
        }
      }));
    }
    $[0] = id;
    $[1] = t1;
    $[2] = toggleFilterOption;
    $[3] = T0;
    $[4] = activeOptions;
    $[5] = label;
    $[6] = t2;
    $[7] = t3;
  } else {
    T0 = $[3];
    activeOptions = $[4];
    label = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[10] !== T0 || $[11] !== activeOptions || $[12] !== label || $[13] !== t2) {
    t4 = <T0 items={t2} selectedItems={activeOptions} groupName={label} bindValues={true} />;
    $[10] = T0;
    $[11] = activeOptions;
    $[12] = label;
    $[13] = t2;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
MobileProductListingListFilter.propTypes = {
  id: PropTypes.string
};
export default MobileProductListingListFilter;
function _temp(t0) {
  const {
    isActive
  } = t0;
  return isActive;
}
function _temp2(option) {
  return option.id;
}